import fetch from 'isomorphic-fetch';
import * as ActionType from '../types/website/ThemeActionTypes';
import * as ActionTypeV2 from '../types/website/ThemeListingActionTypes';

export function getThemesRequest() {
  return {
    type: ActionType.THEMES_REQUESTED
  };
}

export function getThemesResponse(response) {
  return {
    type: ActionType.THEMES_RECEIVED,
    payload: { themes: response }
  };
}

export function getThemeResponse(response) {
  return {
    type: ActionType.THEME_RECEIVED,
    payload: response
  };
}

export function resetTheme2Listings() {
  return {
    type: ActionTypeV2.THEME_RECEIVED
  };
}

export function getThemes(offset) {
  return (dispatch) => {
    dispatch(getThemesRequest());
    return fetch(`/web-api/v1/theme/list?offset=${offset}&limit=20`,
      {
        credentials: 'same-origin'
      }
    )
      .then(response => response.json())
      .then(json => dispatch(getThemesResponse(json)));
  };
}

export function getByKey(themeKey) {
  return (dispatch) => {
    dispatch(getThemesRequest());
    return fetch(`/web-api/v1/theme/${themeKey}`,
      {
        credentials: 'same-origin'
      }
    )
      .then(response => response.json())
      .then(json => dispatch(getThemeResponse(json)));
  };
}

// for new theme detail request
export function getThemesRequestV2() {
  return {
    type: ActionTypeV2.THEMES_REQUESTED
  };
}

export function onResetThemeKey() {
  return {
    type: ActionTypeV2.RESET_THEMEKEY,
    payload: ''
  };
}

// new theme details response

export function getThemeResponseV2(response) {
  return {
    type: ActionTypeV2.THEME_RECEIVED,
    payload: response
  };
}

// new theme detail action function
export function getByKeyV2(themeKey) {
  return (dispatch) => {
    dispatch(getThemesRequestV2());
    return fetch(`/web-api/v2/theme/${themeKey}`,
      {
        credentials: 'same-origin',
      }
    )
      .then(response => response.json())
      .then(json => dispatch(getThemeResponseV2(json)));
  };
}

export function setFromZolaUpdate() {
  return {
    type: ActionTypeV2.CHANGE_FLAG
  };
}

export function storeCurrentThemeKey(themeKey, themeGroupKey) {
  return {
    type: ActionTypeV2.STORE_THEMEDETAIL_KEY,
    payload: { themeKey, themeGroupKey }
  };
}

// color filtering reset
export function resetThemes() {
  return {
    type: ActionTypeV2.THEMES_RESET
  };
}

export function unMountComponent() {
  return {
    type: ActionTypeV2.THEME_GROUP_RESET
  };
}

//  initial theme request
export function getThemeListingRequest() {
  return {
    type: ActionTypeV2.THEMES_REQUESTED
  };
}
//  initial theme response
export function getThemeListingResponse(response) {
  return {
    type: ActionTypeV2.THEMES_RECEIVED,
    payload: response
  };
}
// initial theme post request
export function getThemesV2(offset) {
  return (dispatch, getState) => {
    const colors = getState().website.themeListing.selected_color_keys;
    dispatch(getThemeListingRequest());
    return fetch('/web-api/v2/theme/list',
      {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          selected_color_keys: colors,
          offset,
        })
      }
    )
      .then(response => response.json())
      .then(json => dispatch(getThemeListingResponse(json)));
  };
}

// for theme variation persistence not theme setting - allows user to select variation and see variation in theme detail as first option
export function updateCurrentTheme(theme) {
  return {
    type: ActionTypeV2.CHANGE_CURRENT_THEME,
    payload: { theme }
  };
}

export function resetCurrentTheme() {
  return {
    type: ActionTypeV2.RESET_CURRENT_THEME
  };
}

// color filtering selected
export function getThemesFiltering(selectedColorKeys) {
  return {
    type: ActionTypeV2.THEME_FILTER_SELECTED,
    payload: { selected_color_keys: selectedColorKeys }
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/website/ThemeActions.js
 **/